var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.2856,
    cy: 19,
    r: 19,
    fill: "#F7F7F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27397_62006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3203 12.8075C31.1734 12.2649 30.887 11.7701 30.4895 11.3726C30.092 10.9751 29.5973 10.6887 29.0547 10.5418C27.0681 10 19.0727 10 19.0727 10C19.0727 10 11.0769 10.0164 9.09026 10.5582C8.54761 10.7051 8.05291 10.9915 7.65541 11.3891C7.25791 11.7866 6.97149 12.2813 6.82466 12.824C6.22376 16.3538 5.99066 21.7324 6.84116 25.121C6.988 25.6636 7.27443 26.1584 7.67193 26.5559C8.06943 26.9534 8.56413 27.2398 9.10676 27.3867C11.0934 27.9285 19.089 27.9285 19.089 27.9285C19.089 27.9285 27.0845 27.9285 29.071 27.3867C29.6136 27.2399 30.1083 26.9534 30.5059 26.5559C30.9034 26.1584 31.1898 25.6637 31.3367 25.121C31.9705 21.5862 32.1658 16.2109 31.3203 12.8075Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5277 22.8086L23.1605 18.9668L16.5277 15.125V22.8086Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27397_62006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.6,
    height: 18,
    fill: "white",
    transform: "translate(6.28564 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.018adcfe75194f46f71b083cda88998e.svg";
export { ForwardRef as ReactComponent };